<template>
  <div :id="app_id">
    <v-tabs
      class="px-1"
      background-color="transparent"
      slider-size="2"
      v-model="tab"
      dark
      grow
    >
      <v-tabs-slider></v-tabs-slider>
      <v-tab>
        {{ $t("segments") }}
      </v-tab>
      <v-tab>
        {{ $t("origins_agencies") }}
      </v-tab>
    </v-tabs>
    <v-tabs-items v-model="tab" class="transparent">
      <v-tab-item>
        <v-card>
          <v-card-text>
            <market-segments
              :market_segments="segments_store.market_segments"
              @getMarketSegments="getMarketSegments"
            ></market-segments>
          </v-card-text>
        </v-card>
      </v-tab-item>
      <v-tab-item>
        <segments-channels-related-app
          origins_agencies
          @getSegments="getSegments"
        ></segments-channels-related-app>
      </v-tab-item>
    </v-tabs-items>
  </div>
</template>

<script>
import { mapState } from "vuex";
import MarketSegments from "@/components/segments/MarketSegments.vue";
import SegmentsChannelsRelatedApp from "@/components/app/settings/segmentsChannelsRelatedApp.vue";

export default {
  name: "segmentsChannelsMarketsegmentsApp",
  components: {
    MarketSegments,
    SegmentsChannelsRelatedApp
  },
  data: () => ({
    app_id: "segments-channels-marketsegments-app",
    tab: 0
  }),
  computed: {
    ...mapState({
      segments_store: state => state.segmentschannels
    })
  },
  methods: {
    getSegments() {
      this.$emit("getSegments");
    },
    getMarketSegments() {
      this.$emit("getMarketSegments");
    }
  }
};
</script>

<style lang="scss" scoped></style>
